import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Tag } from 'antd';
import moment from 'moment';
import useAuthContext from '../../contexts/AuthContext';
import useErrorMessage from '../../utils/ErrorMessage';
import { tasksStatuses, contractsTypes } from '../../utils/constants/tagColors';
import { routes, subRoutes } from '../../utils/constants/routes';

const useColumns = () => {
  const { t } = useTranslation();
  const { user } = useAuthContext();
  const { message } = useErrorMessage();
  const { dispatchAPI } = useAuthContext();
  const [statusList, setStatusList] = useState([]);

  const getEnum = async () => {
    try {
      const { data } = await dispatchAPI('GET', { url: '/contracts/enums' });
      setStatusList(data.statuses.filter((f) => f !== 'QUOTE'));
    } catch (e) {
      if (e.response) message(e.response.status);
    }
  };

  useEffect(() => {
    (async () => {
      await getEnum();
    })();
    // eslint-disable-next-line
  }, []);

  return [
    ...(user?.role !== 'guests:GUEST'
      ? [
          {
            title: t('contracts.column.client'),
            dataIndex: 'customer',
            key: 'customer',
            render: (customer, data) => (
              <Link
                to={`${routes.CONTRACTS}${subRoutes.CONTRACTS.PORTFOLIO_CLIENTS}/show/${data.key}`}
              >
                {customer && `${customer.first_name} ${customer.last_name}`}
              </Link>
            ),
            sorter: true
          }
        ]
      : []),
    {
      title: t('contracts.column.number'),
      dataIndex: 'number',
      key: 'number',
      render: (number) => number,
      sorter: true
    },
    {
      title: t('contracts.column.contractType'),
      dataIndex: 'type',
      key: 'type',
      render: (contractType) => (
        <Tag color={contractsTypes[contractType]}>
          {t(`contracts.tags.${contractType}`)}
        </Tag>
      ),
      sorter: true,
      width: 80
    },
    {
      title: t('contracts.form.contract_status'),
      key: 'status',
      dataIndex: 'status',
      sorter: true,
      render: (status) =>
        status && (
          <Tag color={tasksStatuses[status]}>
            {t(`contracts.tags.${status}`)}
          </Tag>
        ),
      filters: statusList.map((p) => ({
        text: t(`contracts.tags.${p}`),
        value: p
      }))
    },
    {
      title: t('contracts.column.start_date'),
      dataIndex: 'effective_date',
      key: 'effective_date',
      render: (date) => date && moment(date).format('L'),
      sorter: true
    },
    ...(user?.role !== 'guests:GUEST'
      ? [
          {
            title: t('contracts.column.exemption_link'),
            dataIndex: 'exemption_link',
            key: 'exemption_link',
            render: (exemption_link) =>
              exemption_link
                ? t('quotes.form.switch.true')
                : t('quotes.form.switch.false'),
            sorter: true
          }
        ]
      : []),
    {
      title: t('contracts.column.insurer'),
      dataIndex: 'insurer',
      key: 'insurer',
      width: 140,
      render: (insurer) => insurer.name,
      sorter: true
    }
  ];
};

export default useColumns;
